import React, { useState } from "react"
import MetaTags from 'react-meta-tags';
import {
  Container,
  Card, CardBody, Table,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Button,
} from "reactstrap"
import { Link } from "react-router-dom"
import { get } from "../../helpers/api_helper"
import * as url from "../../helpers/url_helper"
import { connect } from "react-redux"
import Select from "react-select"


const UnplannedForms = props => {

  const [loading, setLoading] = React.useState(true);
  const [assets, setAssets] = React.useState([]);

  const [forms, setForms] = React.useState([]);
  const [formId, setFormId] = React.useState(null);

  const [editThis, setEditThis] = React.useState(null);
  const [editing, setEditing] = React.useState(false);

  const [query, setQuery] = React.useState('');

  const fetchData = () => {
    setLoading(true);
    // console.log('::ID:', props.location.state.id);
    get(url.GET_UNPLANNED_FORMS+'/'+props.filterBlock.id).then(response => {
      console.log('RESP', response);
      if (response.status == 200) {
        setAssets(response.data.assets);
        setForms(response.data.forms);
        setLoading(false);
      }
      else {
        setAssets(null);
        setLoading(false);
      }
    })
      .catch(error => {
        console.log('err:', error);
      });
  };


  React.useEffect(()=>{
    if(props.filterBlock) {
      setQuery('');
      fetchData();
    }
  }, [props.filterBlock]);

  const displayed = query == '' ? assets : assets.filter(a => a.name.toLowerCase().includes(query.toLowerCase()));

  // const searchRes = this.props.members.filter(item => item.name.toLowerCase().includes(this.state.query.toLowerCase()))


  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>Unplanned Task Forms</title>
        </MetaTags>
        <Container fluid>
          <div className="d-flex justify-content-between align-items-center">
            <h3 className="mb-4">Unplanned Tasks Scheduler</h3>
            {/* <Link className="btn btn-secondary" to="/forms/index">Back</Link> */}
          </div>
          {assets.length < 1 ?
            <div>No assets to show</div> :
            <div>
              <div className="mb-4">
                <input type="text" className="form-control" placeholder="Search.." id="query" value={query} onChange={(e) => { setQuery(e.target.value); }} />
              </div>
              <Card>
                <CardBody>
                  <Table striped>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Asset Name</th>
                        <th>Building</th>
                        <th>Floor</th>
                        <th>Room</th>
                        <th>Form</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                    <tbody>
                      {displayed.map((asset, assetIdx) => (
                      <tr key={assetIdx}>
                          <td className="">
                            {assetIdx+1}
                          </td>
                          <td className="">
                            {asset.name}
                          </td>
                          <td className="">
                            {asset.building?.name || '-'}
                          </td>
                          <td className="">
                            {asset.floor?.name || '-'}
                          </td>
                          <td className="">
                            {asset.room?.name || '-'}
                          </td>
                          <td className="" onClick={()=>{ setEditThis(asset); }}>
                            {asset.form ? <span className="text-success">{asset.form.name}</span> : 
                              <span className="text-muted">-</span>}
                          </td>
                          <td className="">                            
                            <Link className="btn btn-link" target="_blank" to={{pathname: "/assets/edit/"+asset.id, query: asset}}>
                              Edit
                            </Link>
                          </td>
                      </tr>
                      ))}
                    </tbody>
                  </Table>
                </CardBody>
              </Card>
            </div>
          }


          { editThis !== null &&
          <Modal isOpen={editThis !== null} centered>
            <ModalHeader toggle={()=>{ setEditThis(null); }}>Select Form</ModalHeader>
            <ModalBody>
              Choose the default escalation form for {editThis.name}
              <br />
              <Select
                classNamePrefix="select2-selection"
                placeholder="Select one.."
                title="Activity Type"
                options={forms}
                value={formId}
                onChange={e => { 
                  // setServiceType(e); 
                  // setSelectedGroups([]); 
                }}
              />
            </ModalBody>
            <ModalFooter>
              <Button color="primary" disabled={editing} onClick={()=>{}}>Save</Button>{' '}
              <Button color="link" onClick={setEditThis(null)}>Cancel</Button>
            </ModalFooter>
          </Modal>
          }



          <div className="mb-4 container">
            <div className="d-flex justify-content-center">
              <Link className="btn btn-light" to="/forms/index">Back</Link>
            </div>
          </div>

        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStatetoProps = (state) => {
  const {
    filterBlock,
  } = state.filters
  return { filterBlock }
}

export default connect(mapStatetoProps)(UnplannedForms)